import { ClassValue } from 'clsx';
import React, { CSSProperties } from 'react';
import { View } from '@shared/components/View';
import classNames from './MBNotificationBadge.module.css';

export interface MBNotificationBadgeProps {
  count: number;
  className?: ClassValue;
  style?: CSSProperties;
  testID?: string;
}

/*
    Small red dot badge showing notifications. If the count is 100 or more,
    we simply show "99+"
*/
export function MBNotificationBadge({ count, className, style, testID }: MBNotificationBadgeProps) {
  return (
    <View center className={[classNames.badge, className]} style={style} testID={testID}>
      {toString(count)}
    </View>
  );
}

function toString(count: number): string {
  if (count > 99) {
    return `99+`;
  }
  return String(count);
}
